//src/components/StickyHeader.tsx hardened/refactored v1
import React from "react";
import "../index.css";

const StickyHeader: React.FC = () => {
  return (
    <div className="sticky-header">
      <span style={{ fontFamily: "'Fredoka', sans-serif", fontWeight: 600 }}>
        Crushes Make Better Matches
      </span>
    </div>
  );
};

export default StickyHeader;